import useSWR from 'swr'

import { backendFetchResultData } from '../common/api'
import { urlWithParams } from '../common/urls'
import { CustomerAddress } from './models'

export const fetchCustomerAddresses = async (
  _: string,
  customerGid: string
): Promise<CustomerAddress[]> => {
  return await backendFetchResultData('GET', urlWithParams('/customers/addresses', { customerGid }))
}

// Pass `enabled: false` to skip the request (e.g. while the dialog that shows the addresses is closed)
export const useCustomerAddressesSWR = (customerGid: string, enabled = true) =>
  useSWR<CustomerAddress[]>(
    enabled ? ['customer-addresses', customerGid] : null,
    fetchCustomerAddresses
  )
